import { useEffect, useState } from 'react';
import GenericElement from '../Utils/GenericElement';
import loadJsonData from '../Utils/loadJsonData';
import LocalStorage from 'Helpers/MFXLocalStorage';
import URLS from '../Utils/URLs.API';
import Loading from 'Components/Lib/Elements/Loading';
import { getDayShort, getDurationInMinutesABS, minuteToHHMM, toDateFormat, toISOOffset } from '../../../Helpers/dateHelper';
import InputElement from '../Elements/InputElement';
import loadJsonPut from '../Utils/jsonPut';
import Editbutton from '../Elements/Editbutton';
import { eventBus } from '../Utils/eventBus';

export function TimeRecordingPositionsView(props: any) {
    const [data, setData] = useState(null as any);
    const [loading, setLoading] = useState(true);
    const [fromDate, setFromDate] = useState(startOfMonth(new Date()) as any);
    const [toDate, setToDate] = useState(endOfMonth(new Date()) as any);
    const [workingTypes, setWorkingTypes]: any = useState(null);

    useEffect(() => {
        if (fromDate !== null && toDate !== null) loadData();
    }, [fromDate, toDate]);

    useEffect(() => {
        loadJsonData('/' + LocalStorage.getConnectionKey() + URLS.GetDropdownValues + 'WorkingTimeType').then((data: any) => {
            if (data.Meta.Success && data.Data) {
                setWorkingTypes(data.Data);
            }
        });
    }, []);

    //#region eventBus
    const [eventCounter, setEventCounter] = useState(0);

    useEffect(() => {
        if (eventCounter > 0) {
            loadData();
        }
    }, [eventCounter]);

    useEffect(() => {
        registerEventBus();
    }, []);

    const sendMessage = () => {
        eventBus.emit('message', 'Update');
    };

    function registerEventBus() {
        const handleMessage = msg => {
            setEventCounter(prev => prev + 1);
        };

        eventBus.on('message', handleMessage);

        // Clean up when the component unmounts
        return () => {
            eventBus.off('message', handleMessage);
        };
    }
    //#endregion eventBus

    function loadData() {
        setLoading(true);
        let start = toDateFormat(fromDate);
        let end = toDateFormat(toDate);
        loadJsonData('/' + LocalStorage.getConnectionKey() + URLS.GetTimeRecordingEntries + '?Data.Filter.BeginDate=' + start + '&Data.Filter.EndDate=' + end).then((data: any) => {
            if (data.Meta.Success && data.Data && data.Data.TimeRecordingEntriesData) {
                setData(data.Data.TimeRecordingEntriesData);
            }
            setLoading(false);
        });
    }

    function endOfMonth(date) {
        return new Date(date.getFullYear(), date.getMonth() + 1, 0, 12, 0, 0);
    }

    function startOfMonth(date) {
        return new Date(date.getFullYear(), date.getMonth(), 1, 12, 0, 0);
    }

    function onChange(id, key, newValue) {
        /*if ((key === 'WorkingTimeFrom' && data[id].WorkingTimeUntil && new Date(newValue) > new Date(data[id].WorkingTimeUntil)) || (key === 'WorkingTimeUntil' && data[id].WorkingTimeFrom && new Date(data[id].WorkingTimeFrom) > new Date(newValue))) {
                console.log('WorkingTimeFrom > WorkingTimeUntil');
                return;
            }*/

        data[id][key] = newValue;
        if (key === 'Date') {
            if (data[id].WorkingTimeFrom) {
                var newWorkingTimeFrom = new Date(newValue);
                data[id].WorkingTimeFrom = new Date(data[id].WorkingTimeFrom);
                newWorkingTimeFrom.setHours(data[id].WorkingTimeFrom.getHours(), data[id].WorkingTimeFrom.getMinutes(), data[id].WorkingTimeFrom.getSeconds());
            }
            if (data[id].WorkingTimeUntil) {
                var newWorkingTimeUntil = new Date(newValue);
                data[id].WorkingTimeUntil = new Date(data[id].WorkingTimeUntil);
                newWorkingTimeUntil.setHours(data[id].WorkingTimeUntil.getHours(), data[id].WorkingTimeUntil.getMinutes(), data[id].WorkingTimeUntil.getSeconds());
            }
        }
        if ((key === 'WorkingTimeFrom' || key === 'WorkingTimeUntil') && data[id].Date) {
            let currentTime = new Date(newValue);
            let currentDate = new Date(data[id].Date);
            currentTime.setFullYear(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
            data[id][key] = currentTime;
        }

        setData(data.map(o => ({ ...o })));
    }

    function save(e) {
        setLoading(true);
        e.preventDefault();
        var body = {
            Data: {
                TimeRecordingEntriesData: [
                    ...data.map(d => {
                        return { ...d, Text: d.Text ?? '', Duration: d.Duration > 0 && d.Duration < 15 ? d.Duration : getDurationInMinutesABS(d.WorkingTimeFrom, d.WorkingTimeUntil), WorkingTimeFrom: toISOOffset(d.WorkingTimeFrom), WorkingTimeUntil: toISOOffset(d.WorkingTimeUntil) };
                    }),
                ],
            },
        };
        loadJsonPut('/' + LocalStorage.getConnectionKey() + URLS.UpdateTimeRecordingEntries, body).then((data: any) => {
            loadData();
            sendMessage();
        });
    }
    console.log(data);
    return (
        <div className="mfx-view-timerecording">
            <div className="mfx-action-buttons">
                <Editbutton saveChangeHandler={e => save(e)} />
            </div>
            <div className="mfx-from-to-date-wrapper">
                <InputElement
                    uniqueIndex="from"
                    customerData={fromDate}
                    designData={{ Type: 'date', Defaultvalue: fromDate, Key: 'ChangeDate', Label: 1586 }}
                    disableMode={false}
                    onChangeHandler={e => {
                        if (!e.newValue || e.newValue === '') {
                            setFromDate(null);
                        }
                        if (e.newValue instanceof Date && !isNaN(e.newValue)) {
                            setFromDate(new Date(e.newValue));
                        }
                    }}></InputElement>
                <InputElement uniqueIndex="until" customerData={toDate} designData={{ Type: 'date', Defaultvalue: toDate, Key: 'ChangeDate', Label: 1587 }} disableMode={false} onChangeHandler={e => setToDate(new Date(e.newValue))}></InputElement>
            </div>
            {data && !loading && (
                <div className="mfx-table-container time-recording-positions">
                    <table className="mfx-table" style={{ width: 'unset', tableLayout: 'auto' }}>
                        {loading && <Loading />}

                        <>
                            <tr>
                                {props.designer?.TableElements &&
                                    props.designer?.TableElements[0] &&
                                    Object.entries(props.designer.TableElements[0]).map((designer: any, idx) => {
                                        return <th style={{ color: designer[1].ReadOnly ? 'var(--gray)' : 'var(--fontColor)' }}>{window.Dictionary.getTranslation(designer[1].Label)}</th>;
                                    })}
                            </tr>
                            {data.map((d, id) => {
                                return (
                                    <tr id={'tr-table-timerecording-' + id} className={d.ReleasedAt ? 'disabled' : ''}>
                                        {props.designer?.TableElements &&
                                            props.designer?.TableElements[0] &&
                                            Object.entries(props.designer.TableElements[0]).map((designer: any, idx) => {
                                                var value = d[designer[1].Key];
                                                switch (designer[1].Key) {
                                                    case 'Day':
                                                        value = getDayShort(d.Date) + '.';
                                                        break;
                                                    case 'Duration':
                                                        if (d.Duration > 0 && d.Duration < 15) {
                                                            break;
                                                        }
                                                        value = getDurationInMinutesABS(d.WorkingTimeFrom, d.WorkingTimeUntil);
                                                        break;
                                                    case 'DurationTime':
                                                        if (d.Duration === 1) {
                                                            value = '1T';
                                                            break;
                                                        }
                                                        value = minuteToHHMM(getDurationInMinutesABS(d.WorkingTimeFrom, d.WorkingTimeUntil));
                                                        break;
                                                    case 'WorkingType':
                                                        return (
                                                            <td>
                                                                <div className="mfx-input-element">
                                                                    <select
                                                                        className="workingtype-select"
                                                                        disabled={d.ReleasedAt}
                                                                        id={'working-type-select-' + idx}
                                                                        value={d.CustomWorkingType + '-' + d.WorkingType}
                                                                        onChange={e => {
                                                                            onChange(id, designer[1].Key2, e.target.value.split('-')[0]);
                                                                            onChange(id, designer[1].Key, e.target.value.split('-')[1]);
                                                                        }}>
                                                                        {workingTypes?.map((t, inx) => {
                                                                            return (
                                                                                <option id={'working-type-option-' + idx + '-' + inx} value={t.Value}>
                                                                                    {' '}
                                                                                    {t.Value.split('-')[0]} - {t.Name}
                                                                                </option>
                                                                            );
                                                                        })}
                                                                    </select>
                                                                </div>
                                                            </td>
                                                        );
                                                }
                                                return (
                                                    <td>
                                                        <GenericElement disableMode={d.ReleasedAt} fitContent={true} noLabel={true} customData={value} designData={{ ...designer[1] }} key={id + idx} index={idx} onChangeGenericElement={e => onChange(id, e.designData.Key, e.newValue)} />
                                                    </td>
                                                );
                                            })}
                                    </tr>
                                );
                            })}
                        </>
                    </table>
                </div>
            )}
        </div>
    );
}
